import React from "react";
import { render } from "react-dom";
import { App } from "./app";
import "./styles.scss";
render(React.createElement(React.Fragment, null,
    React.createElement(App, null)), document.getElementById("root"));
